import { Component, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SearchRecipeFormGroup } from '@shared/models/recipe/recipe.model';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { CopyByMarketPopinComponent } from '@recipes/recipes-search/recipes-search-query/recipe-headband/copy-by-market-popin/copy-by-market-popin.component';
import { EMPTY, Subject } from 'rxjs';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataRef, Language, Market } from '@shared/models/dataref.model';
import { RecipeService } from '@services/recipe/recipe.service';
import { NotificationService } from '@services/notification.service';

export interface FilteredData {
  filteredMarkets: Market[];
  filteredLanguages: Language[];
}

@Component({
  selector: 'app-recipe-headband',
  templateUrl: './recipe-headband.component.html',
  styleUrls: ['./recipe-headband.component.scss'],
  imports: [MatButtonModule, TranslateModule, MatTooltipModule],
})
export class RecipeHeadbandComponent implements OnDestroy {
  @Input() queryForm: FormGroup<SearchRecipeFormGroup>;
  @Input() filteredData: FilteredData;
  @Input() languages: Language[];
  @Input() statuses: DataRef[];
  private readonly destroy$ = new Subject<void>();

  constructor(
    public dialog: MatDialog,
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
    private readonly recipeService: RecipeService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  copyByMarket(): void {
    const dialogRef = this.dialog.open(CopyByMarketPopinComponent, {
      width: '700px',
      data: {
        domain: this.queryForm.controls.domain.value,
        market: this.queryForm.controls.market.value,
        lang: this.queryForm.controls.lang.value,
        filteredData: this.filteredData,
        languages: this.languages,
        statuses: this.statuses,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(
        takeUntil(this.destroy$),
        switchMap((result) => {
          if (result) {
            return this.recipeService.copyByMarket(result).pipe(
              tap(() => {
                this.notificationService.sendSuccess(this.translateService.instant('COPY_RECIPES_MARKET.MODAL.MSG.SUCCESS'));
              }),
              catchError(() => {
                this.notificationService.sendError(this.translateService.instant('COPY_RECIPES_MARKET.MODAL.MSG.ERROR.DEFAULT'));
                return [];
              }),
            );
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe();
  }

  isButtonDisabled(): boolean {
    return !this.queryForm.controls.domain.value || !this.queryForm.controls.market.value || !this.queryForm.controls.lang.value;
  }
}
